/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  cta: {
    connexion: 'Conexión',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    send: 'Enviar',
    donate: 'Donar',
    description: 'Descripción',
    history: 'Historial',
    goto_forgot_password: '¿Olvidaste tu contraseña?',
    goto_login: 'Volver a la pantalla de inicio de sesión',
    start: 'Iniciar la sesión',
    settings: 'Configurar el efecto',
    start_exercise: 'Comenzar',
    restart: 'Reiniciar',
    restart_exercise: 'Continuar el ejercicio',
    pause_exercise: 'Pausa',
    skip_exercise: 'Saltar',
    next_exercise: 'Siguiente',
    authorize: 'Permitir',
    cancel: 'Cancelar',
    close: 'Cerrar',
    save: 'Guardar',
    modify: 'Modificar',
    back: 'Regresar',
    confirm: 'De acuerdo',
    support: 'Ayuda',
    verify: 'Verificar',
    mfa_resend: 'Reenviar el código',
  },
};
